import Utils from '../../utils/Utils';

let isEnableb;
let isRibbonFlagsEnabled = false;
let delay = 0;

// OTT
let loadLive = false;

const init = () => {
    const meta = Utils.getApaMetadataKey('ribbons_delay_iptv','{"enable":true, "delay": 3}');
    if (meta && typeof meta == 'object') {
        isRibbonFlagsEnabled = meta.enable;
        delay = meta.delay;
    }
};

const isEnableRibbons = () => {
    return isEnableb;
};

const setIsEnabled = (value) => {
    isEnableb = value;
};

const isToogleLevelsDelay = () => {
    return isRibbonFlagsEnabled;
};

const delayLevels = () => {
    return delay * 1000;
};

const setIsLoadLive = (value) => {
    loadLive = value;
}

const isLoadLive = ()  => {
    return loadLive;
}

const LoadingIptvOttFlow = {
    init,
    isEnableRibbons,
    setIsEnabled,
    isToogleLevelsDelay,
    delayLevels,
    isLoadLive,
    setIsLoadLive
};

export default LoadingIptvOttFlow;



// WEBPACK FOOTER //
// ./src/AAF/LoaderExp/LoadingIptvOttFlow.js